const ANDROID_LATEST_JSON_URL =
  'https://app-download.drhhh.com/app_version/bjq9f6ubx/android/latest.json';
const ANDROID_APK_FILE_NAME = 'DRHHH.apk';

let cachedApkUrl = null;

function isWeChat() {
  return /micromessenger/i.test(navigator.userAgent);
}

function isPC() {
  const ua = navigator.userAgent;
  const isMobileUA =
    /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini|tablet|playbook|silk/i.test(ua);
  if (!isMobileUA) return true;
  return window.innerWidth >= 1024;
}

function applyApkUrl(url) {
  if (!url) return;
  cachedApkUrl = url;
  document.querySelectorAll('[data-drh-apk-link], .drh-download-page__apk-link').forEach((link) => {
    link.setAttribute('href', url);
  });
}

async function resolveApkUrl() {
  if (cachedApkUrl) return cachedApkUrl;
  try {
    const res = await fetch(ANDROID_LATEST_JSON_URL, {credentials: 'omit'});
    if (!res.ok) return null;
    const data = await res.json();
    if (typeof data.download_url === 'string' && data.download_url) {
      applyApkUrl(data.download_url);
      return data.download_url;
    }
  } catch (error) {
    console.warn('[drh-download] failed to load latest.json', error);
  }
  return null;
}

function initDownloadPage() {
  const root = document.querySelector('[data-drh-download-page]');
  if (!root) return;

  const mobile = root.querySelector('[data-drh-download-mobile]');
  const pc = root.querySelector('[data-drh-download-pc]');
  const wechatMask = root.querySelector('[data-drh-wechat-mask]');

  const showDeviceLayout = () => {
    const usePc = isPC();
    if (mobile) mobile.hidden = usePc;
    if (pc) pc.hidden = !usePc;
    if (wechatMask && usePc) wechatMask.hidden = true;
  };

  showDeviceLayout();
  window.addEventListener('resize', showDeviceLayout, {passive: true});

  resolveApkUrl();

  root.querySelectorAll('[data-drh-store-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (isWeChat()) {
        event.preventDefault();
        if (wechatMask) wechatMask.hidden = false;
      }
    });
  });

  root.querySelectorAll('[data-drh-apk-link]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      if (isWeChat()) {
        event.preventDefault();
        if (wechatMask) wechatMask.hidden = false;
        return;
      }

      event.preventDefault();
      const apkUrl = (await resolveApkUrl()) || link.getAttribute('href');
      if (!apkUrl) return;

      const anchor = document.createElement('a');
      anchor.href = apkUrl;
      anchor.download = ANDROID_APK_FILE_NAME;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDownloadPage);
} else {
  initDownloadPage();
}
